'use strict';

/**
 * View for rendering the selection of a set in modal update/select set
 *
 * @category   View
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Collection = require('base/Colido.Collection');
var ColidoCompositeView = require('base/Colido.CompositeView');
var ShareColumnsListItemView = require('./share-columns-list-item');

var template = require('../../templates/partials/share-columns-list.hbs');

var ShareColumnsListView = ColidoCompositeView.extend({
    template: template,

    className: 'page-col-4',

    childViewContainer: '.table-columns',

    childView: ShareColumnsListItemView,

    childViewOptions: function() {
        return {
            setModel: this.getOption('setModel'),
            shareModel: this.getOption('shareModel'),
        };
    },

    childEvents: {
        'item:toggled': 'save',
    },

    collectionEvents: {
        'change sync': 'render',
    },

    initialize: function() {
        var shareModel = this.getOption('shareModel');

        this.collection = new Collection(shareModel.getDetailFields());

        this.listenTo(shareModel, 'change', this.resetShareFieldsCollection.bind(this));
    },

    resetShareFieldsCollection: function() {
        var shareModel = this.getOption('shareModel');

        this.collection.reset(shareModel.getDetailFields());
    },

    save: function() {
        var shareModel = this.getOption('shareModel');

        var activeDetailFields = _.map(this.$('input:checked'), function(input) {
            return $(input).val();
        });

        shareModel.save({
            activeDetailFields: activeDetailFields,
        },
        {
            patch: true,
        });
    },
});

module.exports = ShareColumnsListView;